<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { get } from 'svelte/store';
    import { openModal } from 'svelte-modals';
    import { api } from '../../../stores/api';
    import ButtonSmallBlue from '../../shared/ButtonSmallBlue.svelte';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import { JobModifyTimeWindowRuleApi, type CsvImportResponseType } from './JobModifyTimeWindowRuleApi';
    import ModalCsvImportResult from './ModalCsvImportResult.svelte';

    const dispatch = createEventDispatcher();

    const REQUIRED_COLUMNS = ['realizacja_od', 'realizacja_do', 'odb_miejscowosc', 'odb_adres', 'odb_kod'];

    let fileInput: HTMLInputElement;
    let importing: boolean = false;
    let importProgress: string = '';
    let importResult: CsvImportResponseType | null = null;
    let importError: string = '';

    function validateCsvHeader(csvText: string): string | null {
        const firstLine = csvText.split('\n')[0] ?? '';
        const headers = firstLine.split(';').map(h => h.trim().toLowerCase());
        const missing = REQUIRED_COLUMNS.filter(col => !headers.includes(col));
        if (missing.length > 0) {
            return $_('missing_columns', { values: { columns: missing.join(', ') } });
        }
        return null;
    }

    async function handleFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) return;

        importing = true;
        importProgress = $_('loading_file', { values: { name: file.name } });
        importResult = null;
        importError = '';

        try {
            const csvText = await file.text();

            const headerError = validateCsvHeader(csvText);
            if (headerError) {
                importError = headerError;
                importing = false;
                importProgress = '';
                return;
            }

            importProgress = $_('importing_data');
            const result = await JobModifyTimeWindowRuleApi.importFromCsv(get(api), csvText);
            importResult = result;
            importProgress = $_('import_complete_count', { values: { success_count: result.success_count, error_count: result.error_count } });
            if (result.success_count > 0) {
                dispatch('importComplete');
            }
        } catch (err) {
            console.error('Błąd importu:', err);
            importError = $_('import_error', { values: { err } });
            importProgress = $_('import_failed');
        } finally {
            importing = false;
            input.value = '';
            openModal(ModalCsvImportResult, {
                statusMessage: importProgress,
                errorMessage: importError,
                rowErrors: importResult?.errors ?? [],
            });
        }
    }
</script>

<div style="display: flex; flex-direction: column; gap: 10px;">
    <input
        bind:this={fileInput}
        type="file"
        accept=".csv"
        style="display: none;"
        on:change={handleFileSelected}
    />
    <ButtonSmallBlue
        disabled={importing}
        text={$_('import_csv')}
        on:click={() => fileInput.click()}
    />

    {#if importing}
        <div style="padding: 10px; background-color: #f0f0f0; border-radius: 4px; max-width: 600px;">
            <div style="display: flex; align-items: center; gap: 10px;">
                <IconPending spin={true} scale={0.6} />
                <span>{importProgress}</span>
            </div>
        </div>
    {/if}

</div>

